import { useTranslation } from "react-i18next";

import { IconUserUp01 } from "@pentabd/icons";
import { Header } from "@pentabd/ui";

export function PromotionListPageHeader() {
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      icon: <IconUserUp01 fill="dark" size="20" />,
    },
    {
      label: t("PROMOTION_LIST.BREADCRUMBS.FIRST_STEP"),
    },
  ];

  const headerText = {
    header: t("PROMOTION_LIST.HEADING"),
    subHeader: t("PROMOTION_LIST.DESCRIPTION"),
  };

  return (
    <Header
      headerText={headerText}
      breadcrumbs={breadcrumbs}
      // actions={[
      //   <Button size="sm" type="primary">
      //     <IconFile05 size="20" fill="white" />
      //     {t('PROMOTION_LIST.ACTION')}
      //   </Button>,
      // ]}
    />
  );
}
